// extracted by mini-css-extract-plugin
export default {"iconCheckbox":"hcaFVj4qcC9MuHHPZr15"};